import React, { useEffect, useState } from 'react'
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";

const LeadChatList = () => {
    const [chat, setChart] = useState({})
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [filter, setFilter] = useState({
        date: new Date().toISOString().slice(0, 10),
    });


    const fetchChart = async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await axios.get('public/api/report/leads-chats', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })


            setChart(response.data)
        } catch (error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem("token");
                navigate("/crm/");
            }
        }
    }

    useEffect(() => {
        fetchChart();
    }, [])


    const handleFilter = async () => {
        try {
            const token = localStorage.getItem("token");
            // const queryParams = new URLSearchParams({
            //     date: filter.date,
            // }).toString();


            const response = await axios.get(`public/api/report/leads-chats?date=${filter.date}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setChart(response?.data)

        } catch (error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem("token");
                navigate("/crm/");
            }
        }
    }

    const resetFilters = () => {
        setFilter({
            date: new Date().toISOString().slice(0, 10),
        });
        fetchChart();
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilter({
            ...filter,
            [name]: value,
        });
    };

    if (loading) {
        return (
            <div className="h-screen bg-white">
                <div className="flex justify-center items-center h-full">
                    <img
                        className="h-16 w-16"
                        src="https://icons8.com/preloaders/preloaders/1488/Iphone-spinner-2.gif"
                        alt="loader"
                    />
                </div>
            </div>
        );
    }
    return (
        <div>
            <div className="p-6">
                <h2 className="text-2xl font-bold mb-6">Lead Chat </h2>

                <div className="grid grid-cols-1 sm:grid-cols-5 gap-4 items-end mt-4">
                    <div className="space-y-3 ">
                        {/* PO Date Select */}
                        <div className="">
                            <label className="block text-sm font-medium text-gray-700">
                                Date
                            </label>
                            <input
                                type="date"
                                name="date"
                                value={filter.date}
                                onChange={handleChange}
                                className="mt-1 w-full rounded border border-gray-300 p-2 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200 "
                            />
                        </div>
                    </div>
                </div>

                <div className="flex flex-wrap gap-4 mt-4">
                    {/* Submit Button */}
                    <button
                        // ref={submitBtnRef}
                        onClick={() => handleFilter(1)}
                        className="bg-blue-600 text-white font-semibold py-2 px-6 rounded-md hover:bg-blue-700 transition"
                    >
                        Submit
                    </button>

                    {/* Reset Button */}
                    <button
                        onClick={resetFilters}
                        className="bg-gray-200 text-gray-800 font-semibold py-2 px-6 rounded-md hover:bg-gray-300 transition"
                    >
                        Reset
                    </button>
                </div>

                {chat?.grouped_by_enquiry_no && (
                    <div className="space-y-7 mt-4">
                        {Object.entries(chat.grouped_by_enquiry_no).map(
                            ([enquiryNo, discussions], idx) => (
                                <div
                                    key={idx}
                                    className="bg-white shadow-xl border border-gray-200 rounded-2xl p-6 mb-10"
                                >
                                    {/* ENQUIRY TITLE BOX */}
                                    <div className="mb-6 p-4 bg-blue-50 border-l-4 border-blue-600 rounded-md">
                                        <h3 className="text-lg font-bold text-blue-700">
                                            Enquiry No: {enquiryNo}
                                        </h3>
                                      
                                        <p className="text-sm text-gray-600 mt-1">
                                            Party: <span className="font-semibold text-gray-800">
                                                {discussions[0]?.lead?.customer_name}
                                            </span>
                                        </p>
                                          <p className="text-sm text-gray-600 mt-1">
                                            Mobile No: <span className="font-semibold text-gray-800">
                                                {discussions[0]?.lead?.contact_no}
                                            </span>
                                        </p>
                                         <p className="text-sm text-gray-600 mt-1">
                                            Type Of Work: <span className="font-semibold text-gray-800">
                                                {discussions[0]?.lead?.type_of_work.map((item) => item.name).join(", ")}
                                            </span>
                                        </p>
                                    </div>

                                    {/* TIMELINE CONTAINER */}
                                    <div className="relative bg-gray-50 p-4 sm:p-6 rounded-xl">

                                        {/* Center Vertical Line – hide on mobile */}
                                        <div className="hidden sm:block absolute left-1/2 top-0 -translate-x-1/2 w-1 bg-gray-300 h-full"></div>

                                        <div className="space-y-8 sm:space-y-12">
                                            {discussions.map((item, index) => {
                                                const isLeft = index % 2 === 0;

                                                return (
                                                    <div
                                                        key={index}
                                                        className={`flex w-full ${isLeft ? "sm:justify-start" : "sm:justify-end"}  justify-center`}
                                                    >
                                                        {/* Chat Card */}
                                                        <div
                                                            className={`  w-full sm:w-[46%] bg-white border shadow-sm p-4 rounded-xl relative ${isLeft ? "sm:mr-10" : "sm:ml-10"} `}
                                                        >
                                                            {/* Dot – hide on mobile */}
                                                            <div
                                                                className={`hidden sm:block absolute top-5 w-4 h-4 bg-blue-600 rounded-full border-4 border-white shadow ${isLeft ? "-right-8" : "-left-8"}`}
                                                            ></div>

                                                            {/* Header */}
                                                            <div className="flex justify-between items-center flex-wrap gap-2">
                                                                <h4 className="font-semibold text-base sm:text-lg">
                                                                    {item.worker_tally_id || "-"}
                                                                </h4>

                                                                <span className="text-xs sm:text-sm text-gray-500 whitespace-nowrap">
                                                                    {new Date(item.created_at).toLocaleDateString("en-GB")}
                                                                </span>
                                                            </div>

                                                            {/* Message */}
                                                            {item.message && (
                                                                <p className="text-gray-700 mt-2 text-sm sm:text-base">
                                                                    {item.message}
                                                                </p>
                                                            )}

                                                            {/* Images */}
                                                            {item.discussion_images?.length > 0 && (
                                                                <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 mt-3">
                                                                    {item.discussion_images.map((img, i) => (
                                                                        <img
                                                                            key={i}
                                                                            src={`${axios.defaults.baseURL}/${img?.image}`}
                                                                            alt="discussion"
                                                                            className="w-full h-24 object-cover rounded-md border"
                                                                        />
                                                                    ))}
                                                                </div>
                                                            )}

                                                            {/* Status */}
                                                            <div className="text-xs sm:text-sm text-gray-600 mt-3">
                                                                Status:{" "}
                                                                <span className="font-semibold capitalize">
                                                                    {item.status}
                                                                </span>
                                                            </div>

                                                            {/* Follow-up Date */}
                                                            {item?.next_followup_date && (
                                                                <div className="text-xs sm:text-sm text-gray-600 mt-1">
                                                                    Next Followup Date:{" "}
                                                                    <span className="font-semibold">
                                                                        {new Date(item.next_followup_date).toLocaleDateString("en-GB")}
                                                                    </span>
                                                                </div>
                                                            )}
                                                            {item?.loss_reason && (
                                                                <div className="text-xs sm:text-sm text-gray-600 mt-1">
                                                                    Loss Reason:{" "}
                                                                    <span className="font-semibold">
                                                                        {item?.loss_reason?.reason}
                                                                    </span>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>

                                </div>
                            )
                        )}



                    </div>
                )}

                {chat?.grouped_by_enquiry_no?.length === 0 && (
                    <p>No discussions found.</p>
                )
                }
            </div>






        </div>
    )
}

export default LeadChatList